import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import ambiente from '../../config/ambienteConfig';

class Proventos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proventos: [],
            proventosAnuais: [],
        };
    }

    componentDidMount = () => {
        this.updateGrafico();
    }

    updateGrafico = async () => {
        const res = await axios.get(`${ambiente.dev.server}/relatorios/proventos`);
        this.setState({ proventos: res.data });
        const resAno = await axios.get(`${ambiente.dev.server}/relatorios/proventos?anual=true`);
        this.setState({ proventosAnuais: resAno.data });
    }

    render() {
        return (
            <div>
                <div>
                    <BarChart width={1000} height={300} data={this.state.proventos}>
                        <XAxis dataKey="data" />
                        <YAxis />
                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar dataKey="div" fill="#4286f4" stackId="a" />
                        <Bar dataKey="jcp" fill="#41f44a" stackId="a" />
                        <Bar dataKey="alug" fill="#f44170" stackId="a" />
                        <Bar dataKey="cupom" fill="#f9b043" stackId="a" />
                        <Bar dataKey="rend" fill="#ad43f9" stackId="a" />
                        <Tooltip cursor={false}/>
                    </BarChart>
                </div>
                <div>
                    <BarChart width={1000} height={300} data={this.state.proventosAnuais}>
                        <XAxis dataKey="data" />
                        <YAxis />
                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar dataKey="div" fill="#4286f4" stackId="a" />
                        <Bar dataKey="jcp" fill="#41f44a" stackId="a" />
                        <Bar dataKey="alug" fill="#f44170" stackId="a" />
                        <Bar dataKey="cupom" fill="#f9b043" stackId="a" />
                        <Bar dataKey="rend" fill="#ad43f9" stackId="a" />
                        <Tooltip cursor={false}/>
                    </BarChart>
                </div>
            </div>
        );
    }
}

Proventos.propTypes = {
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired
  };
  
  function mapStateToProps({filtro}) {
    return {
        filtro: filtro
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      updateFilter: filtro => dispatch(updateFilter(filtro)),
      cleanFilter: () => dispatch(cleanFilter())
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Proventos);



// WEBPACK FOOTER //
// ./src/components/graficos/Proventos.js